module.exports = __webpack_public_path__ + "static/img/amaraGelFullFaceMask.6ee8384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/amaraGelFullFaceMask.png
// module id = aUoZ
// module chunks = 1